// relationshipLabel.js
const RELATIONSHIP_LABELS = {
  father:   "Father",
  mother:   "Mother",
  son:      "Son",
  daughter: "Daughter",
  spouse:   "Spouse",
  wife:     "Spouse",
  husband:  "Spouse",
  brother:  "Brother",
  sister:   "Sister",
  bro:      "Brother",
  sis:      "Sister",
  other:    "Other",
};

const INVERSE_RELATIONSHIP = {
  father:   "son",
  mother:   "daughter",
  son:      "father",
  daughter: "mother",
  brother:  "sister",
  sister:   "brother",
  spouse:   "spouse",
  wife:     "spouse",
  husband:  "spouse",
  other:    "other",
};

export function getInverseRelationshipLabel(type) {
  if (!type) return "Relative";
  const key = String(type).toLowerCase();
  const inversedKey = INVERSE_RELATIONSHIP[key] || key;
  return RELATIONSHIP_LABELS[inversedKey] ||
    (inversedKey.charAt(0).toUpperCase() + inversedKey.slice(1));
}

export default function relationshipLabel(type) {
  if (!type) return "Relative";
  const key = String(type).toLowerCase();
  return RELATIONSHIP_LABELS[key] ||
    (key.charAt(0).toUpperCase() + key.slice(1));
}